import {
  BabaSpecialOffer,
  BagelCodeSpecialOffer,
  BanditosSpecialOffer,
  BingoPopSpecialOffer,
  CashFrenzySpecialOffer,
  CashmanCasinoSpecialOffer,
  DecaSpecialOffer,
  DefaultStudioSpecialOffer,
  DrimageSpecialOffer,
  FabelTownSpecialOffer,
  GennmuSpecialOffer,
  GhostSpecialOffer,
  HugeSpecialOffer,
  JunesJourneySpecialOffer,
  LoadCompleteSpecialOffer,
  LocoBingoSpecialOffer,
  MatchMastersSpecialOffer,
  Me2onSpecialOffer,
  PipaSpecialOffer,
  PlaySimpleSpecialOffer,
  PokerFaceSpecialOffer,
  ProductMadnessSpecialOffer,
  SpinXSpecialOffer
} from '@appcharge/shared-ui';

import { ESpecialOfferInternalViewModel } from '../constants/enums';

export const mapSpecialOffers: Record<ESpecialOfferInternalViewModel, any> = {
  [ESpecialOfferInternalViewModel.HUGE]: HugeSpecialOffer,
  [ESpecialOfferInternalViewModel.MATCH_MASTERS]: MatchMastersSpecialOffer,
  [ESpecialOfferInternalViewModel.POKER_FACE]: PokerFaceSpecialOffer,
  [ESpecialOfferInternalViewModel.BAGELCODE]: BagelCodeSpecialOffer,
  [ESpecialOfferInternalViewModel.LOCO_BINGO]: LocoBingoSpecialOffer,
  [ESpecialOfferInternalViewModel.ME2ON]: Me2onSpecialOffer,
  [ESpecialOfferInternalViewModel.PIPA]: PipaSpecialOffer,
  [ESpecialOfferInternalViewModel.BABA]: BabaSpecialOffer,
  [ESpecialOfferInternalViewModel.JACKPOT_SLOTS]: ProductMadnessSpecialOffer,
  [ESpecialOfferInternalViewModel.BIG_FISH_CASINO]: ProductMadnessSpecialOffer,
  [ESpecialOfferInternalViewModel.PLAY_SIMPLE]: PlaySimpleSpecialOffer,
  [ESpecialOfferInternalViewModel.GHOST]: GhostSpecialOffer,
  [ESpecialOfferInternalViewModel.BINGO_POP]: BingoPopSpecialOffer,
  [ESpecialOfferInternalViewModel.FABEL_TOWN]: FabelTownSpecialOffer,
  [ESpecialOfferInternalViewModel.DECA]: DecaSpecialOffer,
  [ESpecialOfferInternalViewModel.LOAD_COMPLETE]: LoadCompleteSpecialOffer,
  [ESpecialOfferInternalViewModel.SPIN_X]: SpinXSpecialOffer,
  [ESpecialOfferInternalViewModel.CASH_FRENZY]: CashFrenzySpecialOffer,
  [ESpecialOfferInternalViewModel.GENNMU]: GennmuSpecialOffer,
  [ESpecialOfferInternalViewModel.BANDITOS]: BanditosSpecialOffer,
  [ESpecialOfferInternalViewModel.JUNES_JOURNEY]: JunesJourneySpecialOffer,
  [ESpecialOfferInternalViewModel.STUDIO_DEFAULT]: DefaultStudioSpecialOffer,
  [ESpecialOfferInternalViewModel.DRIMAGE]: DrimageSpecialOffer,
  [ESpecialOfferInternalViewModel.CASHMAN_CASINO]: CashmanCasinoSpecialOffer
};

export const mapViewModelDisplayName: Record<ESpecialOfferInternalViewModel, string> =
  {
    [ESpecialOfferInternalViewModel.HUGE]: 'Huge',
    [ESpecialOfferInternalViewModel.MATCH_MASTERS]: 'Match Masters',
    [ESpecialOfferInternalViewModel.POKER_FACE]: 'Poker Face',
    [ESpecialOfferInternalViewModel.BAGELCODE]: 'Bagelcode',
    [ESpecialOfferInternalViewModel.LOCO_BINGO]: 'Loco Bingo',
    [ESpecialOfferInternalViewModel.ME2ON]: 'Me2on',
    [ESpecialOfferInternalViewModel.PIPA]: 'Pipa',
    [ESpecialOfferInternalViewModel.BABA]: 'Baba',
    [ESpecialOfferInternalViewModel.JACKPOT_SLOTS]: 'Jackpot Slots',
    [ESpecialOfferInternalViewModel.BIG_FISH_CASINO]: 'Big Fish Casino',
    [ESpecialOfferInternalViewModel.PLAY_SIMPLE]: 'Play Simple',
    [ESpecialOfferInternalViewModel.GHOST]: 'Ghost Studio',
    [ESpecialOfferInternalViewModel.BINGO_POP]: 'Bingo Pop',
    [ESpecialOfferInternalViewModel.FABEL_TOWN]: 'Fabel Town',
    [ESpecialOfferInternalViewModel.DECA]: 'Deca',
    [ESpecialOfferInternalViewModel.LOAD_COMPLETE]: 'Load Complete',
    [ESpecialOfferInternalViewModel.SPIN_X]: 'Spinx JC',
    [ESpecialOfferInternalViewModel.CASH_FRENZY]: 'Spinx CF',
    [ESpecialOfferInternalViewModel.GENNMU]: 'Gennmu',
    [ESpecialOfferInternalViewModel.BANDITOS]: 'Banditos',
    [ESpecialOfferInternalViewModel.JUNES_JOURNEY]: 'Junes Journey',
    [ESpecialOfferInternalViewModel.STUDIO_DEFAULT]: 'Studio',
    [ESpecialOfferInternalViewModel.DRIMAGE]: 'Drimage',
    [ESpecialOfferInternalViewModel.CASHMAN_CASINO]: 'Cashman Casino'
  };
